import { JSX } from 'solid-js';
import { Accordion } from '../../../ui-components/accordion/accordion';

type Props = {
    heading: string;
    children: JSX.Element;
    initialOpen?: boolean;
};

export const ExpandableProductContainer = (props: Props) => (
    <Accordion heading={props.heading} initialOpen={props.initialOpen}>
        {props.children}
    </Accordion>
);
